@let isMenuPage = pageIs().menu;
@let isReserveTable = pageIs().reserveTable;
@let isServicePage = pageIs().service;
@let isMorePage = pageIs().more;
@let callWaiterMain = this.callWaiterMain();

<div
  [class.hide]="hideTabBar()"
  class="tab-bar"
>
  <div class="tabs" coreActivitySection="TabBar">
    <button
      class="tab"
      [class.active]="isMenuPage"
      [routerLink]="isMenuPage ? '/main/home' : '/main/menu'"
      [coreUserActivityClickTracking]="isMenuPage ? 'MenuClose' : 'MenuOpen'"
    >
      <svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" fill="none">
        <path stroke="currentColor" stroke-width="2" d="M15 4.8a1.6 1.6 0 0 1 1.5 1.5l.3 8a22.6 22.6 0 0 1 15-5.7c7.4 0 14 3.6 18.1 9 .6-3.6 1.6-7 3.6-11.3A2 2 0 0 1 55.4 5c1.1 0 2 1 2 2l.5 26.3.4 21.6a3.2 3.2 0 0 1-3.3 3.3 3.2 3.2 0 0 1-3.2-3.4l.5-13.7a22.7 22.7 0 0 1-38.7 4l.4 9.7a3.3 3.3 0 0 1-3.2 3.4 3.3 3.3 0 0 1-3.3-3.4l.8-21.7.4-8.2a.5.5 0 0 0-.5-.5A3.4 3.4 0 0 1 4.7 21v-5.7l.2-9a1.6 1.6 0 0 1 1.7-1.5h.1a1.6 1.6 0 0 1 1.5 1.5l.3 10a.2.2 0 0 0 .2.2.2.2 0 0 0 .2-.1l.2-10a1.6 1.6 0 0 1 1.6-1.7h.2a1.6 1.6 0 0 1 1.5 1.6l.3 10.1a.2.2 0 0 0 .4 0v-1l.2-9a1.6 1.6 0 0 1 1.6-1.7h.2Zm16.8 4.8a21.6 21.6 0 0 0-15 6l.1 5.3a3.6 3.6 0 0 1-3.5 3.6.5.5 0 0 0-.6.5l.3 8.2.5 10a21.7 21.7 0 0 0 38.8-5l.2-4.8V29a.7.7 0 0 0-.6-.7h-1c-.9 0-1.7-.8-1.7-1.8 0-2.8.2-5.2.4-7.5-3.9-5.7-10.5-9.5-18-9.5Z"/>
        <circle cx="31.5" cy="31.5" r="14" stroke-width="2" stroke="currentColor"/>
      </svg>
      <div class="label">Menu</div>
    </button>

    <button
      class="tab"
      [class.active]="isReserveTable"
      [routerLink]="isReserveTable ? '/main/home' : '/main/reserve-table'"
      [coreUserActivityClickTracking]="isReserveTable ? 'ReserveTableClose' : 'ReserveTableOpen'"
    >
      <svg class="icon" width="64" height="64" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M5.4 31.5c0-9.9 0-14.8 3-18 3.1-3 8-3 18-3h10.5c9.9 0 14.8 0 17.9 3 3 3.2 3 8.1 3 18v5.3c0 9.8 0 14.8-3 17.9-3 3-8 3-18 3H26.5c-10 0-14.9 0-18-3-3-3.1-3-8-3-18v-5.2Z" stroke-width="2" stroke="currentColor"/>
        <path d="M18.5 10.5v-4m26.3 4v-4" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
        <circle cx="43.4" cy="43.3" r="3.9" stroke-width="2" stroke="currentColor"/>
        <path d="M6.7 23.6h49.9" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
      </svg>
      <div class="label">RESERVE TABLE</div>
    </button>

    <button
      class="tab"
      [class.active]="isServicePage"
      [routerLink]="isServicePage ? '/main/home' : '/main/service'"
      [coreUserActivityClickTracking]="isServicePage ? 'ServiceClose' : 'ServiceOpen'"
    >

      <svg class="icon" width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M53.965 56.258h-43.93A7.566 7.566 0 0 1 2.47 48.69v-2.903H61.53v2.903a7.566 7.566 0 0 1-7.566 7.566ZM32 18.928a5.593 5.593 0 1 0 0-11.186 5.593 5.593 0 0 0 0 11.186Z"
          stroke="currentColor" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
        <path
          d="M54.512 33.277c-3.95-8.475-12.545-14.35-22.512-14.35m0 0c-13.71 0-24.824 11.115-24.824 24.825v2.036H42.53M32 18.928c13.71 0 24.825 11.114 24.825 24.824v2.036"
          stroke="currentColor" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
      <div class="label">Service</div>
      <app-call-waiter-indicator
        [type]="callWaiterMain ? 'main' : 'bill'"
        class="indicator"
      />
    </button>

    <button
      class="tab"
      [class.active]="isMorePage"
      [routerLink]="isMorePage ? '/main/home' : '/main/more'"
      [coreUserActivityClickTracking]="isMorePage ? 'MoreClose' : 'MoreOpen'"
    >
      <svg class="icon" width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M53 18.875H11M53 32H11M53 45.125H11" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
      </svg>
      <div class="label">More</div>
    </button>
  </div>
</div>

@if (hideTabBar()) {
  <core-interacts-present/>
}
